import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { UsuarioContext } from "../../../providers/userContext";
import { getListFincas } from "../../../services";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useRecogerURLParamsFiltros,
  construirURLParamsFiltros,
} from "./../../../functions/parametrosURL/funcionesParamsURL";
import ComunidadesOriginal from "./diseños/original/comunidades";
import ComunidadesLegalia from "./diseños/legalia/comunidades";
import { saveNavContext } from "../../../functions/navOrder";
import { ventaMasReciente, GRUPOS_SERVICIO } from "../../../functions/funciones";

const Comunidades = (props) => {
  const { t } = useTranslation(['properties', 'common', 'aaff']);
  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();

  const [busqueda, setBusqueda] = useState(filtrosIniciales);
  const [loading, setLoading] = useState(true);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const user = useContext(UsuarioContext);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const navigate = useNavigate();
  const location = useLocation();

  const clearFilters = () => {
    setBusqueda({});
    setClearFilterActivo(true);
  };

  const fetchData = async ({
    offset,
    limit,
    filtros = busqueda,
    order,
    orderBy,
  } = {}) => {
    orderBy = orderBy || filtroOrder.ordenadoPor || "id";
    order = order || filtroOrder.orden || "ASC";

    construirURLParamsFiltros(
      navigate,
      offset || 1,
      limit || 50,
      filtros,
      order,
      orderBy
    );
    // Contexto para las flechas anterior/siguiente del detalle de comunidad.
    saveNavContext('comunidades', { filtros, order, orderBy });

    const payload = {
      filtros,
      params: { page: offset, limit, order, orderBy },
    };

    try {
      setLoading(true);
      const response = await getListFincas(payload);
      const { meta, data } = response;
      setData({
        meta,
        rows: formatData(data, meta),
      });
      console.log("DATA COMUNIDADES", data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatData = (data, meta) => {
    const formattedData = [];
    data.map((row, i) => {
      // console.log(row)
      // const diferenciaMeses = diferenciaMesesCaducidad(row.fechaRenovacion, row.createdAt)
      const sale_cae = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cae);
      const sale_lopd = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.lopd);
      const sale_cai = ventaMasReciente(row?.sales, GRUPOS_SERVICIO.cai);
      formattedData.push({
        i: (meta.current_page - 1) * meta.per_page + (i + 1),
        aaff_nif: row?.aaff?.nif,
        aaff_razonSocial: row?.aaff?.razonSocial,
        razonSocial: row.razonSocial,
        nif: row.nif,
        direccion: row.direccion,
        codigoPostal: row.codigoPostal,
        municipio: row.municipio,
        provincia: row.provincia,
        proveedores: row.sale_cae ? row.num_suppliers : t('management.noHasSuppliers'),
        isWorkcenter: false,
        activo: row.activo === null ? true : row.activo,
        estado: row.estado_id === null ? 1 : row.estado_id,
        ultimaVisita: row.visitSheets[0]?.createdAt
          ? new Date(row.visitSheets[0]?.createdAt).getFullYear()
          : "",
        saleCae_id: row.sale_cae,
        porcentajeDocs: row.porcentajeDocs === undefined ? 0 : row.porcentajeDocs,
        saleLopd_id: row.sale_lopd,
        saleCai_id: row.sale_cai,
        instalacionKae_id: row.instalacion_kae,
        estadoCae: row.estado_cae
          ? row.estado_cae === null
            ? 1
            : row.estado_cae
          : "-",
        estadoLopd: row.estado_lopd
          ? row.estado_lopd === null
            ? 1
            : row.estado_lopd
          : "-",
        estadoCai: row.estado_cai
          ? row.estado_cai === null
            ? 1
            : row.estado_cai
          : "-",
        estadoKae: row.estado_kae
          ? row.estado_kae === null
            ? 1
            : row.estado_kae
          : "-",
      });
      if (row.workcenters?.length > 0) {
        row.workcenters?.forEach((wc) => {
          formattedData.push({
            i: "",
            aaff_nif: "",
            aaff_razonSocial: "",
            razonSocial: wc.razonSocial,
            nif: "",
            codigoPostal: "",
            municipio: "",
            provincia: "",
            proveedores: "",
            isWorkcenter: true,
            activo: "",
            estadoCae: "",
            estadoLopd: "",
            estadoCai: "",
            saleCae_id: "",
            saleLopd_id: "",
            saleCai_id: "",
          });
        });
      }
    });
    return formattedData;
  };

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
  };

  return (
    user.tieneLegalia ? 
      <ComunidadesLegalia
        t={t}
        user={user}
        data={data}
        loading={loading}
        fetchData={fetchData}
        busqueda={busqueda}
        filtrarDatos={filtrarDatos}
        clearFilters={clearFilters}
        busquedaActiva={busquedaActiva}
        setBusquedaActiva={setBusquedaActiva}
        clearFilterActivo={clearFilterActivo}
        setClearFilterActivo={setClearFilterActivo}
        nif={props.params.nif}
      />
    :
      <ComunidadesOriginal
        t={t}
        user={user}
        data={data}
        loading={loading}
        fetchData={fetchData}
        busqueda={busqueda}
        filtrarDatos={filtrarDatos}
        clearFilters={clearFilters}
        busquedaActiva={busquedaActiva}
        setBusquedaActiva={setBusquedaActiva}
        clearFilterActivo={clearFilterActivo}
        setClearFilterActivo={setClearFilterActivo}
        nif={props.params.nif}
      />
  );
};

export default withRouter(Comunidades);
